import { render, staticRenderFns } from "./ProductPromo.vue?vue&type=template&id=b25b2b20&functional=true&"
import script from "./ProductPromo.vue?vue&type=script&lang=js&"
export * from "./ProductPromo.vue?vue&type=script&lang=js&"
import style0 from "./ProductPromo.vue?vue&type=style&index=0&id=b25b2b20&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  null,
  null
  
)

export default component.exports